import { merge } from 'lodash'
const modalComponentState = {
  component: {},
  isLoading: false,
  layout: {
    isHeader: false,
    isFooter: false
  },
  data: {},
  callBack: () => {}
}

const routeState = {
  isHeader: true,
  isFooter: true
}

export const state = {
  isShowSideBar: false,
  modalAlertComponents: [],
  modalComponents: [],
  routeLayout: {
    ...routeState
  }
}
export const getters = {
  getIsLoading: (state) => {
    return state.isLoading
  },
  getIsShowSideBar: (state) => {
    return state.isShowSideBar
  },
  getModalAlertComponents: (state) => {
    return state.modalAlertComponents
  },
  getModalComponents: (state) => {
    return state.modalComponents
  },
  getRouteLayout: (state) => {
    return state.routeLayout
  }
}
export const mutations = {
  setIsShowSideBar(state, { isShowSideBar }) {
    state.isShowSideBar = isShowSideBar
  },
  setModalAlertComponents(state, { modalAlertComponents }) {
    state.modalAlertComponents = modalAlertComponents
  },
  setModalComponents(state, { modalComponents }) {
    state.modalComponents = modalComponents
  },
  setIsLoading(state, { isLoading = false }) {
    state.isLoading = isLoading
  },
  setRouteLayout(state, { isHeader = undefined, isFooter = undefined }) {
    if (isHeader !== undefined) state.routeLayout.isHeader = isHeader
    if (isFooter !== undefined) state.routeLayout.isFooter = isFooter
  }
}
export const actions = {
  updateIsShowDrawer({ commit }, payload) {
    commit('setIsShowSideBar', payload)
  },
  pushModalAlertComponent({ state, commit }, payload) {
    state.modalAlertComponents.push(merge({}, modalComponentState, payload))
    commit('setModalAlertComponents', {
      modalAlertComponents: state.modalAlertComponents
    })
  },
  closeModalAlertComponent({ state, commit }, { index = 0 }) {
    state.modalAlertComponents.splice(index, 1)
    commit('setModalAlertComponents', {
      modalAlertComponents: state.modalAlertComponents
    })
  },
  pushModalComponent({ state, commit }, payload) {
    state.modalComponents.push(merge({}, modalComponentState, payload))
    commit('setModalComponents', {
      modalComponents: state.modalComponents
    })
  },
  closeModalComponent({ state, commit }, { index = 0 }) {
    state.modalComponents.splice(index, 1)
    commit('setModalComponents', {
      modalComponents: state.modalComponents
    })
  },
  updateRouteLayout({ commit }, payload) {
    commit('setRouteLayout', payload)
  },
  updateIsLoading({ commit }, payload) {
    commit('setIsLoading', payload)
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
